import {css, Theme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {borderRadius, calculateRemSize, flex, flexDirection, mb, mt, p} from "@pg-design/helpers-css";
import {BrandArrowTargetFlatIcon} from "@pg-design/icons-module";
import {Highlight, Text} from "@pg-design/text-module";
import {rpAppPath} from "@pg-mono/rp-routes";

export const ListingBanner = () => {
    return (
        <div css={wrapper}>
            <div css={container}>
                <Text as="p" variant="headline_2">
                    Przyspiesz swoje <Highlight>poszukiwania</Highlight>
                </Text>
                <Text>
                    W 3 krokach skonfiguruj swoje idealne mieszkanie, a nasz system rekomendacji dobierze konkretne nieruchomości, idealnie dostosowane do
                    Twoich potrzeb.
                </Text>
                <Button variant="filled_primary" as="a" href={rpAppPath.propertyConfigurator}>
                    Skonfiguruj mieszkanie
                </Button>
            </div>
            <BrandArrowTargetFlatIcon size="26" wrapperSize="26" wrapperColor="transparent" css={iconStyle} />
        </div>
    );
};

const wrapper = (theme: Theme) => css`
    ${flex("center")};
    background-color: #fff;
    ${borderRadius(2)};
    ${p(4)};
    gap: ${calculateRemSize(8)};

    @media (max-width: ${theme.breakpoints.sm}) {
        ${flexDirection("column")};
        gap: ${calculateRemSize(1)};
        align-items: flex-start;
    }
`;

const container = (theme: Theme) => css`
    ${flex("start")};
    width: 80%;
    ${flexDirection("column")};
    gap: ${calculateRemSize(4)};

    @media (max-width: ${theme.breakpoints.sm}) {
        ${mb(4)};
    }
`;

const iconStyle = css`
    ${mt(5)};
    max-height: 140px;
`;
import {css, Theme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {borderRadius, calculateRemSize, flex, flexDirection, mb, mt, p} from "@pg-design/helpers-css";
import {BrandArrowTargetFlatIcon} from "@pg-design/icons-module";
import {Highlight, Text} from "@pg-design/text-module";
import {rpAppPath} from "@pg-mono/rp-routes";

export const ListingBanner = () => {
    return (
        <div css={wrapper}>
            <div css={container}>
                <Text as="p" variant="headline_2">
                    Przyspiesz swoje <Highlight>poszukiwania</Highlight>
                </Text>
                <Text>
                    W 3 krokach skonfiguruj swoje idealne mieszkanie, a nasz system rekomendacji dobierze konkretne nieruchomości, idealnie dostosowane do
                    Twoich potrzeb.
                </Text>
                <Button variant="filled_primary" as="a" href={rpAppPath.propertyConfigurator}>
                    Skonfiguruj mieszkanie
                </Button>
            </div>
            <BrandArrowTargetFlatIcon size="26" wrapperSize="26" wrapperColor="transparent" css={iconStyle} />
        </div>
    );
};

const wrapper = (theme: Theme) => css`
    ${flex("center")};
    background-color: #fff;
    ${borderRadius(2)};
    ${p(4)};
    gap: ${calculateRemSize(8)};

    @media (max-width: ${theme.breakpoints.sm}) {
        ${flexDirection("column")};
        gap: ${calculateRemSize(1)};
        align-items: flex-start;
    }
`;

const container = (theme: Theme) => css`
    ${flex("start")};
    width: 80%;
    ${flexDirection("column")};
    gap: ${calculateRemSize(4)};

    @media (max-width: ${theme.breakpoints.sm}) {
        ${mb(4)};
    }
`;

const iconStyle = css`
    ${mt(5)};
    max-height: 140px;
`;
